export default "__VITE_ASSET__3df6d9ab__"